// ** Initial State
const initialState = {
  data: [],
  bank: [],
  bankcategory: [],
  category: [],
  agent: [],
  bankwallet: [],
  bankwalletaccount: [],
  bankplatform: []
}

const agent = (state = initialState, action) => {
  switch (action.type) {
    case 'AGENT_GET_DATA':
      return {
        ...state,
        data: action.data
      }
    case 'AGENT_BANK':
      return {
        ...state,
        bank: action.data
      }
    case 'AGENT_GATEGORY':
      return {
        ...state,
        category: action.data
      }
    case 'AGENT_BANK_GATEGORY':
      return {
        ...state,
        bankcategory: action.data
      }
    case 'TRANSFER_PARTNER_GET_DATA':
      return {
        ...state,
        data: action.data
      }
    case 'SELECT_AGENTID':
      return {
        ...state,
        agent: action.agent
      }
    case 'SELECT_AGENT_BANK_WELLET':
      return {
        ...state,
        bankwallet: action.data
      }
    case 'SELECT_AGENT_BANK_WELLET_ACCOUNT':
      return {
        ...state,
        bankwalletaccount: action.data
      }
    case 'AGENT_BANK_PAYMENT_711':
      return {
        ...state,
        bankplatform: action.data
      }
    default:
      return { ...state }
  }
}

export default agent